import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.49999 3.66663C4.03975 3.66663 3.66666 4.03972 3.66666 4.49996V8.99996C3.66666 9.36815 3.96513 9.66663 4.33332 9.66663C4.60947 9.66663 4.83332 9.89048 4.83332 10.1666C4.83332 10.4428 4.60947 10.6666 4.33332 10.6666C3.41285 10.6666 2.66666 9.92043 2.66666 8.99996V4.49996C2.66666 3.48744 3.48747 2.66663 4.49999 2.66663H8.99999C9.92047 2.66663 10.6667 3.41282 10.6667 4.33329C10.6667 4.60944 10.4428 4.83329 10.1667 4.83329C9.89051 4.83329 9.66666 4.60944 9.66666 4.33329C9.66666 3.9651 9.36818 3.66663 8.99999 3.66663H4.49999Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.16666 6.33329C6.70642 6.33329 6.33332 6.70639 6.33332 7.16663V11.5C6.33332 11.9602 6.70642 12.3333 7.16666 12.3333H11.5C11.9602 12.3333 12.3333 11.9602 12.3333 11.5V7.16663C12.3333 6.70639 11.9602 6.33329 11.5 6.33329H7.16666ZM5.33332 7.16663C5.33332 6.1541 6.15413 5.33329 7.16666 5.33329H11.5C12.5125 5.33329 13.3333 6.1541 13.3333 7.16663V11.5C13.3333 12.5125 12.5125 13.3333 11.5 13.3333H7.16666C6.15413 13.3333 5.33332 12.5125 5.33332 11.5V7.16663Z"
      fill="currentColor"
    />
  </SvgIcon>
));
